import { useLanguage } from "@/i18n/LanguageContext";

export default function BottomCta() {
  const { t } = useLanguage();
  return (
    <div className="bg-secondary py-16 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
          {t("reviews.ctaTitle")}
        </h2>
        <p className="text-[#fefce8] text-sm md:text-base max-w-2xl mx-auto mb-8">
          {t("reviews.ctaSub")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <a
            href="tel:+17863774452"
            className="inline-flex items-center gap-2 bg-accent text-white px-8 py-3 text-sm font-bold rounded-lg hover:bg-accent/90 transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            {t("hood.callNow")}
          </a>
          <a
            href="mailto:contact@impact-window-repair-miami.com"
            className="inline-flex items-center gap-2 bg-transparent border-2 border-white text-white px-8 py-3 text-sm font-bold rounded-lg hover:bg-white hover:text-secondary transition-colors whitespace-nowrap"
          >
            <i className="ri-mail-line" />
            {t("reviews.emailUs")}
          </a>
        </div>
      </div>
    </div>
  );
}